import { AllegatoModel } from '@core/models/allegato.model';
import { ModelsAllegato } from '@data-access';

export const AllegatoMapper = {
  toModel(a: ModelsAllegato): AllegatoModel {
    return {
      id: a.id,
      nome: a.nome ?? '',
      dimensione: a.size ?? 0,
      storagePath: a.externalName ?? '',
    };
  },
  toDto(a: AllegatoModel): ModelsAllegato {
    return {
      id: a.id,
      nome: a.nome,
      size: a.dimensione,
      externalName: a.storagePath,
    };
  },
};
